module.exports = __webpack_public_path__ + "img/package_fan.6716434d.svg";